module.exports = __webpack_public_path__ + "static/img/login.c85505e1.jpg";